import { Column, GridApi, IRowNode } from 'ag-grid-community';
import { useMemo } from 'react';

type Options = { node: IRowNode; column?: Column; api: GridApi; rowIndex?: number };
export function useEditableInfo({ api, column, node, rowIndex }: Options) {
  const isEditing = useMemo(() => {
    if (!column || rowIndex === undefined) {
      return false;
    }
    return api.isEditing({ rowIndex: rowIndex, column, rowPinned: node.rowPinned });
  }, [api, column, node, rowIndex]);
  const isEditable = useMemo(() => {
    if (column === undefined) {
      return false;
    }
    return column.isCellEditable(node);
  }, [column, node]);
  return { isEditing, isEditable };
}
